import { Alert, Button, Snackbar } from '@mui/material';

import useVersionCheck from 'hooks/useVersionCheck';

// ==============================|| UPDATE AVAILABLE SNACKBAR ||============================== //

/**
 * Persistent, non-auto-hiding banner shown when a newer build has been
 * deployed while this tab was open. The user clicks "Refresh" to reload and
 * pick up the latest version. Unlike the app-wide Snackbar slice, this banner
 * stays visible until acted upon so it is never missed.
 */
const UpdateAvailableSnackbar = () => {
  const updateAvailable = useVersionCheck();

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Snackbar
      open={updateAvailable}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
    >
      <Alert
        severity="warning"
        variant="filled"
        action={
          <Button color="inherit" size="small" onClick={handleRefresh}>
            REFRESH
          </Button>
        }
      >
        A new version is available. Refresh to update the app.
      </Alert>
    </Snackbar>
  );
};

export default UpdateAvailableSnackbar;
